<template>
    <div class="content">
        <h3 class="mb-4">{{ $t("titlePages.CustomerOrdersDetails") }}</h3>

        <card>
            <div class="row justify-content-end">
                <div class="col-xl-3 col-sm-4">
                    <base-input>
                        <el-select
                            filterable
                            class="select-primary"
                            v-model="CategorieSelects.Categorie"
                            :disabled="$apollo.queries.commandesList.loading"
                            :placeholder="
                                $t('table.columns.Product').toUpperCase()
                            "
                            @change="search"
                            clearable
                        >
                            <el-option
                                v-for="option in CategorieSelects.ListCategorie"
                                class="select-primary text-uppercase"
                                :value="option.pk_categorie"
                                :label="option.designation.replace(/Ã©/g, 'é')"
                                :key="option.pk_categorie"
                            >
                            </el-option>
                        </el-select>
                    </base-input>
                </div>
                <div class="col-xl-3 col-sm-4">
                    <base-input>
                        <el-select filterable class="select-primary"
                            v-model="Type_sante"
                            :disabled="$apollo.queries.commandesList.loading"
                            placeholder="TYPE"
                            @change="search"
                            clearable
                        >
                            <el-option class="select-primary" value="salaries" label="SALARIES"></el-option>
                            <el-option class="select-primary" value="seniors" label="SENIORS"></el-option>
                        </el-select>
                    </base-input>
                </div>
                <div class="col-xl-3 col-sm-4">
                    <base-input>
                        <el-select
                            filterable
                            class="select-primary"
                            v-model="Etat"
                            @change="search"
                            :disabled="$apollo.queries.commandesList.loading"
                            :placeholder="$t('table.columns.DeliveryState')"
                        >
                            <el-option
                                class="select-primary"
                                value="encours"
                                :label="$t('labels.InProgress')"
                            ></el-option>
                            <el-option
                                class="select-primary"
                                value="termine"
                                :label="$t('labels.Completed')"
                            ></el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
        </card>
        <!-- <div class="row mb-4">
            <div class="col-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <div class="d-block">
                            <p class="text-muted">Total des commandes : <b>{{this.Sum_quantite}}</b></p>
                            <p class="text-muted">Commandes restantes: <b>{{this.Sum_}}</b></p>
                            <p class="text-muted">{{ $t("labels.TotalDelivered") }}: <b>600</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <card>
            <div class="row" v-if="Etat != 'termine'">
                <!-- Recap -->
                <el-table
                    :data="suntheseCommandes"
                    row-class-name="booking-table-rows"
                    class="customtable_cmd"
                    show-summary
                    :summary-method="getSummaries"
                >
                    <el-table-column
                        prop="designation"
                        label=""
                        width="300"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        prop="capping"
                        label="Volume Par Jour"
                        align="center"
                        show-overflow-tooltip
                        sortable
                    >
                    <template scope="scope">
        <div class="d-flex justify-content-center">
            <span class="text-end">
                {{
                    scope.row.capping
                }}
            </span>
        </div>
    </template>
                    </el-table-column>
                    <el-table-column
                        prop="capping_livre"
                        label="Leads Restants"
                         align="center"
                        show-overflow-tooltip
                        sortable
                    >
                    <template scope="scope">
        <div class="d-flex justify-content-center">
            <span class="text-end">
                {{
                    scope.row.capping_livre
                }}
            </span>
        </div>
    </template>
                    </el-table-column>
                    <el-table-column
                        prop="ca_estimer_par_jour"
                        label="CA estimé"
                         align="center"
                        show-overflow-tooltip
                        sortable
                    >
                        <template scope="scope">
                            {{
                                formatThounsends(
                                    scope.row.ca_estimer_par_jour,
                                    true,
                                    2
                                ) + " €"
                            }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="ca_temp_reel"
                        label="CA Réel"
                         align="center"
                        show-overflow-tooltip
                        sortable
                    >
                        <template scope="scope">
                            {{
                                formatThounsends(
                                    scope.row.ca_temp_reel,
                                    true,
                                    2
                                ) + " €"
                            }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </card>
        <div class="row justify-content-end">
            <!-- <div class="col-xl-2 col-md-3 col-sm-6">
                <base-input>
                    <el-select
                        class="select-primary pagination-select"
                        v-model="pagination.perPage"
                        placeholder="Per page"
                    >
                        <el-option
                            class="select-primary"
                            v-for="item in pagination.perPageOptions"
                            :key="item"
                            :label="item"
                            :value="item"
                        >
                        </el-option>
                    </el-select>
                </base-input>
            </div> -->
            <div class="col-xl-2 col-md-3 col-sm-6 d-none d-md-block">
                <base-button
                    style="float: right"
                    class="btn-link"
                    type="market"
                    size="sm"
                    icon
                    @click="toggleDisplay"
                    :disabled="!filterCommandes"
                >
                    <i
                        :class="
                            displayGird
                                ? 'far fa-square icon-large'
                                : 'fas fa-th-large icon-large'
                        "
                    ></i>
                </base-button>
            </div>
            <!-- [Tous les filtres restent identiques] -->
        </div>

        <!-- Cartes des commandes -->
        <div class="row">
            <div
                class="row w-100 d-flex justify-content-center align-items-center p-2"
            >
                <div v-if="$apollo.queries.commandesList.loading">
                    <div
                        v-loading="true"
                        class="h-100 d-flex justify-content-between align-items-center"
                    ></div>
                    <!-- <div v-loading="true" class="h-100 d-flex justify-content-between align-items-center"></div> -->
                </div>
            </div>
            <div
                class="col-12 my-5 py-5"
                v-if="!$apollo.queries.commandesList.loading && suntheseCommandes.lenght == 0"
            >
                <!-- Header -->

                <div
                    class="h-100 d-flex justify-content-center align-items-center flex-wrap text-muted"
                >
                    Aucune donnée
                </div>
            </div>

            <!-- <div v-for="order in filterCommandes" :key="order.pk_commande" class="col-12 col-md-6 col-lg-4 mb-4"> -->
            <!-- <div v-else v-for="order in filterCommandes" :key="order.pk_commande" class="col-12 mb-4"> -->
            <div
                v-else
                v-for="order in filterCommandes"
                :key="order.pk_commande"
                :class="displayGird ? 'col-12 col-md-6 mb-4' : 'col-12 mb-4'"
            >
                <card class="card shadow-sm h-100">
                    <!-- Header -->

                    <div
                        class="card-header d-flex justify-content-between align-items-center flex-wrap"
                    >
                        <!-- Bloc Logo et Labels -->
                        <div class="d-flex flex-column w-100 w-md-auto">
                            <!-- Logo pack -->
                            <div class="text-left">
                                <img
                                    v-if="
                                        order.ligne_commande[0].pack ===
                                        'exclusif'
                                    "
                                    src="/img/lead_exclusif.png"
                                    alt="EXCLUSIF"
                                    class="img-fluid"
                                    style="max-height: 40px"
                                />
                                <img
                                    v-else-if="
                                        order.ligne_commande[0].pack === 'duo'
                                    "
                                    src="/img/lead_duo.png"
                                    alt="DUO"
                                    class="img-fluid"
                                    style="max-height: 40px"
                                />
                                <img
                                    v-else-if="
                                        order.ligne_commande[0].pack === 'trio'
                                    "
                                    src="/img/lead_trio.png"
                                    alt="TRIO"
                                    class="img-fluid"
                                    style="max-height: 40px"
                                />
                            </div>

                            <!-- Labels -->
                            <!-- <div class="text-center text-md-left">
                                <span
                                    v-if="order.isNew"
                                    class="badge badge-primary text-white mr-1"
                                >
                                    Nouveau client
                                </span>
                                <span
                                    v-if="order.cmd_promo"
                                    class="badge badge-warning text-white"
                                >
                                    Promo
                                </span>
                            </div> -->
                        </div>
                    </div>

                    <!-- Informations principales -->
                    <div class="card-body card-commande px-3">
                        <div class="">
                            <div
                                class="d-flex justify-content-between flex-wrap"
                            >
                                <p class="text-muted mb-0 text-md-right">
                                    {{ order.designation }} <span class="text-uppercase text-muted" v-if="order.fk_categorie === '1' && order.options"> <b>({{order.options}})</b></span>
                                </p>
                                <h4 class="font-weight-bold mb-1 text-md-right">
                                    {{ order.societe.toUpperCase() }}
                                </h4>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div
                                class="d-flex justify-content-between flex-wrap"
                            >
                                <p class="text-muted mb-0 text-md-right">
                                    {{ formatDate(order.date_commande) }}
                                </p>
                                <span class="text-white font-weight-bold"
                                    >{{
                                        formatThounsends(order.montant, true, 2)
                                    }}
                                    €
                                </span>
                            </div>
                        </div>

                        <!-- Barre de progression -->
                        <div class="progress mb-3" style="height: 20px">
                            <div
                                class="progress-bar"
                                :class="{
                                    'bg-success-bar':
                                        getPourcentage(order) >= 50,
                                    'bg-warning': getPourcentage(order) < 50,
                                }"
                                role="progressbar"
                                :style="`width: ${getPourcentage(order)}%`"
                                :aria-valuenow="getPourcentage(order)"
                                aria-valuemin="0"
                                aria-valuemax="100"
                            ></div>
                        </div>
                        <div class="d-flex justify-content-between flex-wrap">
                            <span
                                :class="{
                                    'text-success-bar':
                                        getPourcentage(order) >= 50,
                                    'text-warning':
                                        getPourcentage(order) < 50 &&
                                        getPourcentage(order) > 0,
                                }"
                            >
                                <b>{{ getPourcentage(order).toFixed(2) }}%</b>
                            </span>
                            <span class="text-muted">
                                Restant :
                                {{ formatThounsends(order.tt_qte_restant) }}
                                leads /
                                <b>{{ formatThounsends(order.quantite) }}</b>
                                leads
                            </span>
                        </div>

                        <!-- Infos capping -->

                        <div class="mt-3">
                            <div
                                class="d-flex justify-content-between flex-wrap"
                            >
                                <p class="text-muted mb-1">
                                    Capping :
                                    <b
                                        class="text-white"
                                        v-if="order.lead_par_jour"
                                        >{{ order.lead_par_jour }} leads</b
                                    >
                                    <b class="text-white" v-else>Illimité</b>
                                </p>
                                <p class="text-muted ml-auto mb-1">
                                    CA journalier :
                                    <b class="text-white"
                                        >{{
                                            formatThounsends(
                                                order.ca_estimer_globale,
                                                true,
                                                2
                                            )
                                        }}
                                        €</b
                                    >
                                </p>
                            </div>
                        </div>
                        <div class="mt-2">
                            <div
                                class="d-flex justify-content-between flex-wrap"
                            >
                                <p class="text-muted mb-1" v-if="order.jours">
                                Livraison :
                                <span
                                    v-for="(jour, index) in order.jours.split(
                                        ','
                                    )"
                                    :key="index"
                                    class=""
                                >
                                    {{ jour
                                    }}<span
                                        v-if="
                                            index <
                                            order.jours.split(',').length - 1
                                        "
                                        >,</span
                                    >
                                </span>
                            </p>
                                <p
                                    class="text-muted mb-1 ml-auto"
                                    v-if="getPourcentage(order) < 100"
                                >
                                    Livrés aujourd'hui :
                                    <b
                                        v-if="order.lead_par_jour"
                                        :class="{
                                            'text-success-bar':
                                                order.capping_livre >=
                                                order.lead_par_jour,
                                            'text-warning':
                                                order.capping_livre <
                                                order.lead_par_jour,
                                        }"
                                    >
                                        {{ order.capping_livre }}/{{
                                            order.lead_par_jour
                                        }}
                                    </b>
                                    <b v-else>
                                        {{ order.capping_livre }} / Illimité</b
                                    >
                                </p>
                            </div>
                        </div>

                        <!-- Infos capping -->
                       <!--  <div class="mt-1">
                            <div class="d-flex justify-content-end flex-wrap">
                                <p
                                    class="text-muted mb-1"
                                    v-if="getPourcentage(order) < 100"
                                ></p>
                            </div>
                        </div> -->

                        <!-- Infos livraison et CA -->
                        <!-- <div class="d-flex justify-content-end flex-wrap mt-1">
                                <div
                                    class="progress"
                                    style="height: 15px; width: 162px"
                                >
                                    <div
                                        class="progress-bar"
                                        :class="{
                                            'bg-success-bar':
                                                getPourcentageCapping(order) >=
                                                50,
                                            'bg-warning':
                                                getPourcentageCapping(order) <
                                                50,
                                        }"
                                        role="progressbar"
                                        :style="`width: ${getPourcentageCapping(
                                            order
                                        )}%`"
                                        :aria-valuenow="
                                            getPourcentageCapping(order)
                                        "
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                    {{ getPourcentageCapping(order) }}%
                                </div>
                        </div> -->

                        <div class="d-flex justify-content-end flex-wrap mt-2" style="position: relative;" v-if="order.lead_par_jour && getPourcentage(order) < 100">
    <div class="progress" style="height: 15px; width: 160px; position: relative;">
        <!-- Barre de progression -->
        <div
            class="progress-bar"
            :class="{
                'bg-success-bar': getPourcentageCapping(order) >= 50,
                'bg-warning': getPourcentageCapping(order) < 50,
            }"
            role="progressbar"
            :style="`width: ${getPourcentageCapping(order)}%`"
            :aria-valuenow="getPourcentageCapping(order)"
            aria-valuemin="0"
            aria-valuemax="100"
        ></div>
        <!-- Texte du pourcentage au centre -->
        <span
            class="percentage-text"
            style="
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, 0);
                width: 100%;
                text-align: center;
                font-size: 12px;
                line-height: 15px;
                pointer-events: none;
                color: black; /* ou une autre couleur si le texte doit être lisible */
            "
        >
            {{ getPourcentageCapping(order) }}%
        </span>
    </div>
</div>

                        <!--date fin de commande -->
                        <div
                            class="d-flex justify-content-end flex-wrap mt-2"
                            v-if="order.date_fin_commande"
                        >
                            <p class="text-muted mb-1">
                                Date fin :
                                <b class="text-white"
                                    >{{ formatDate(order.date_fin_commande) }}
                                </b>
                            </p>
                        </div>
                    </div>
                </card>
            </div>
        </div>

        <!-- Pagination -->
        <div class="mt-4 d-flex justify-content-between align-items-center">
            <p class="text-muted">
                {{ $t("labels.Datatable.Showing") }} {{ from + 1 }}
                {{ $t("labels.Datatable.to") }} {{ to }}
                {{ $t("labels.Datatable.of") }} {{ total }}
                {{ $t("labels.Datatable.entries") }}
            </p>

            <base-pagination
                type="market"
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
            />
        </div>
    </div>
</template>


<script>
import { Select, Option, DatePicker } from "element-ui";
import { Table, TableColumn } from "element-ui";
import { BasePagination, BaseSwitch, BaseDropdown } from "src/components";
import StatsCard from "src/components/Cards/StatsCard";
import Fuse from "fuse.js";
import gql from "graphql-tag";
import swal from "sweetalert2";
import { Icons } from "src/pages/Pages/MyMarketAdmin/Product_Icons";
import PerfectScrollbar from "perfect-scrollbar";
import moment from "moment";
moment.locale("fr");

export default {
    apollo: {
        produits: {
            client: "MARKET",
            query: gql`
                query {
                    produits {
                        pk_categorie
                        designation
                    }
                }
            `,
            result({ data, loader, networkStatus }) {
                this.CategorieSelects.ListCategorie = data.produits;
            },
        },
        commandesList: {
            client: "MARKET",
            query: require("src/graphql/leadmarket/commandesList.gql"),
            variables() {
                return {
                    date_debut: this.StartDate,
                    date_fin: this.EndnDate,
                    etat: this.Etat,
                    categorie_id: this.CategorieSelects.Categorie,
                    //categorie_id: 1000,
                };
            },
            result({ data, loader, networkStatus }) {
                this.ListCommande = this.searchCommande =
                    data.commandesList.commandes;
                if (this.searchCommandeOriginale.length === 0) {
                    // Stocker les données originales uniquement lors du premier chargement
                    this.searchCommandeOriginale = data.commandesList.commandes;
                }
                this.fuseSearch = new Fuse(this.ListCommande, this.options);
                this.ListCommande.forEach((cmd) => {
                    cmd.ca_estimer_globale = this.calculateCaEstimer(cmd);
                    if (!this.StartDate && !this.EndnDate) {
                        cmd.ca_reel_globale =
                            cmd.capping_livre *
                            cmd.ligne_commande[0].prix_unitaire;
                    } else {
                        cmd.ca_reel_globale = cmd.details[0]
                            ? cmd.details[0].ca
                            : 0;
                    }
                });
                this.SkipQuery = true;
            },
            fetchPolicy: "network-only",
            skip() {
                return this.SkipQuery;
            },
        },
    },
    watch: {
        searchQuery(value) {
            let result = this.ListCommande;
            if (value !== "" && this.fuseSearch) {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchCommande = result;
        },
        selectallrows(value) {
            this.rows.forEach((element) => {
                element.show = value;
            });
        },
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        StatsCard,
        BasePagination,
        BaseSwitch,
        BaseDropdown,
    },
    data() {
        return {
            searchCommandeOriginale: [],
            displayGird: false,
            total: 0,
            Dayslist: [
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi",
                "dimanche",
            ],
            Type_sante: "",
            Capping_complete: "",
            DaysLivred: [moment().format("dddd")],
            fullscreen: false,
            PerfectScrollbar: null,
            icons: Icons,
            Sum_montant: 0,
            Sum_quantite: 0,
            sum_quantite_rst: 0,
            sum_capping: 0,
            sum_capping_livred: 0,
            sum_ca_estimer_par_jour: 0,
            sum_ca_temp_reel: 0,
            SkipQuery: true,
            searchCommande: null,
            ListCommande: [],
            StartDate: null,
            EndnDate: null,
            fuseSearch: null,
            searchQuery: "",
            CategorieSelects: {
                Categorie: "",
                ListCategorie: [],
            },
            Etat: "encours",
            pagination: {
                perPage: 100,
                currentPage: 1,
                //perPageOptions: [50, 100, 250, 500],
                perPageOptions: [5, 10, 50, 100],
                total: 0,
            },
            options: {
                threshold: 0.2,
                keys: [
                    "pk_commande",
                    "date_commande",
                    "societe",
                    "montant",
                    "designation",
                    "quantite",
                    "tt_qte_restant",
                    "nbre_devalide",
                    "statut",
                    "date_estime",
                    "date_fin_commande",
                    "delai_livraison",
                    "geolocalisation",
                ],
            },
            selectallrows: false,
            rows: [
                { label: "N°", show: false },
                { label: "Date", show: true },
                { label: "Commande en promo", show: true },
                { label: "Client", show: true },
                {
                    label: this.$t("table.columns.AmountOrder") + " (€ HT)",
                    show: true,
                },
                { label: this.$t("table.columns.Product"), show: true },
                {
                    label: this.$t("table.columns.TotalQuantity") + " (leads)",
                    show: true,
                },
                {
                    label:
                        this.$t("table.columns.RemainingQuantity") + " (leads)",
                    show: true,
                },
                {
                    label: "% " + this.$t("table.columns.Invalidation"),
                    show: false,
                },
                { label: this.$t("table.columns.State"), show: true },
                { label: "Capping", show: true },
                {
                    label: this.$t("table.columns.DayCappingDelivery"),
                    show: true,
                },
                {
                    label: this.$t("table.columns.CommunicatedDeliveryDate"),
                    show: false,
                },
                { label: this.$t("table.columns.OrderEndDate"), show: false },
                { label: "Ca estime du jour", show: true },
                { label: "CA réel du jour", show: true },
                { label: this.$t("table.columns.DeliveryTime"), show: true },
                { label: this.$t("table.columns.Geolocation"), show: true },
                { label: "Détails", show: true },
            ],
        };
    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        suntheseCommandes() {
            var list = this.searchCommandeOriginale;
            if (!list || (list && list.length == 0)) {
                return [];
            }
            var designationsUniques = [
                ...this.CategorieSelects.ListCategorie,
            ].sort((a, b) => a.pk_categorie - b.pk_categorie);

            var result = [];
            // Calculer les totaux pour chaque désignation unique
            designationsUniques.map((item) => {
                // Filtrer les commandes pour cette désignation
                const commandesFiltrees = list.filter(
                    (cmd) =>
                        cmd.fk_categorie == item.pk_categorie &&
                        ((cmd.jours + "")
                            .toLowerCase()
                            .match(this.DaysLivred) ||
                            cmd.jours === null)
                );
                //return

                // Calculer les totaux
                const data = {
                    designation: item.designation,
                    montant: commandesFiltrees.reduce(
                        (total, cmd) => total + cmd.montant,
                        0
                    ),
                    quantite: commandesFiltrees.reduce(
                        (total, cmd) => total + cmd.quantite,
                        0
                    ),
                    quantite_rst: commandesFiltrees.reduce(
                        (total, cmd) => total + cmd.tt_qte_restant,
                        0
                    ),
                    capping: commandesFiltrees.reduce(
                        (total, cmd) => total + cmd.lead_par_jour,
                        0
                    ),
                    capping_livre: commandesFiltrees.reduce(
                        (total, cmd) => total + parseInt(cmd.capping_livre),
                        0
                    ),
                    ca_estimer_par_jour: commandesFiltrees.reduce(
                        (total, cmd) => total + cmd.ca_estimer_globale,
                        0
                    ),
                    ca_temp_reel: commandesFiltrees.reduce(
                        (total, cmd) => total + cmd.ca_reel_globale,
                        0
                    ),
                };
                result.push(data);
            });
            this.Sum_montant = 0;
            this.Sum_quantite = 0;
            this.sum_quantite_rst = 0;
            this.sum_capping = 0;
            this.sum_capping_livred = 0;
            this.sum_ca_estimer_par_jour = 0;
            this.sum_ca_temp_reel = 0;
            result.forEach((cmd) => {
                this.Sum_montant += cmd.montant;
                this.Sum_quantite += cmd.quantite;
                this.sum_quantite_rst += cmd.quantite_rst;
                this.sum_capping += cmd.capping;
                this.sum_capping_livred += parseInt(cmd.capping_livre);
                this.sum_ca_estimer_par_jour += cmd.ca_estimer_par_jour;
                this.sum_ca_temp_reel += cmd.ca_temp_reel;
            });
            return result;
        },
        filterCommandes() {
            var list = null;
            try {
                let filteredList = (this.searchCommande || []).filter(item =>
                    this.Type_sante === "" || item.options === this.Type_sante
                );

                //list = this.searchCommande;
                list = filteredList;

                if (!list || (list && list.length == 0)) {
                    return null;
                }
                // sommme :
                /* this.Sum_montant = 0;
                this.Sum_quantite = 0;
                this.sum_quantite_rst = 0;
                this.sum_capping = 0;
                this.sum_capping_livred = 0;
                this.sum_ca_estimer_par_jour = 0;
                this.sum_ca_temp_reel = 0; */
                list.forEach((cmd) => {
                    /* this.Sum_montant += cmd.montant;
                    this.Sum_quantite += cmd.quantite;
                    this.sum_quantite_rst += cmd.tt_qte_restant;
                    this.sum_capping += cmd.lead_par_jour;
                    console.log(this.sum_capping)
                    this.sum_capping_livred += parseInt(cmd.capping_livre);
                    this.sum_ca_estimer_par_jour += cmd.ca_estimer_globale;
                    this.sum_ca_temp_reel += cmd.ca_reel_globale; */
                    cmd.pourcentage = this.getPourcentage(cmd);
                });
                list.sort((a, b) => b.pourcentage - a.pourcentage);
                if (this.Etat === "termine") {
                    // Trier par date_fin_commande la plus récente si l'état est "termine"
                    list.sort(
                        (a, b) =>
                            new Date(b.date_fin_commande) -
                            new Date(a.date_fin_commande)
                    );
                }
                this.total = list.length;
                return list.slice(this.from, this.to);
            } catch (error) {
                console.log(error);
                return null;
            }
        },
    },
    methods: {
        toggleDisplay() {
            this.displayGird = !this.displayGird; // Inverse l'état de displayTwo
        },
        getPourcentage(order) {
            const livre = order.quantite - order.tt_qte_restant;
            return (livre / order.quantite) * 100;
        },
        getPourcentageCapping(order) {
            let pourcentage = 0;
            if (order.lead_par_jour) {
                pourcentage = (order.capping_livre / order.lead_par_jour) * 100;
            }
            return Number.isInteger(pourcentage) ? pourcentage : pourcentage.toFixed(2);;
        },
        formatDate(date) {
            return moment(date).format("DD-MM-YYYY"); // Format : jour-mois-année
        },
        toggle() {
            this.$fullscreen.toggle(this.$el.querySelector(".listcommande"), {
                wrap: false,
                callback: this.fullscreenChange,
            });
        },
        fullscreenChange(fullscreen) {
            this.fullscreen = fullscreen;
            if (fullscreen) {
                this.PerfectScrollbar = new PerfectScrollbar(".listcommande");
            } else {
                this.PerfectScrollbar.destroy();
                this.PerfectScrollbar = null;
            }
        },
        search() {
            this.searchCommande = null;
            this.total = 0;
            if(this.Etat == 'encours' && !this.StartDate && !this.EndnDate && !this.CategorieSelects.Categorie){
                this.searchCommandeOriginale = []
            }
            /* this.StartDate = null;
            this.EndDate = null;
            if( this.Etat == "termine"){
                this.StartDate = moment().startOf('month').format('YYYY-MM-DD');
                this.EndDate = moment().format('YYYY-MM-DD');

            } */
            this.SkipQuery = false;
        },
        changeStatus(row, newstatus) {},
        retraitPause(row) {
            swal.fire({
                title: "Êtes-vous sûr?",
                text: "Vous êtes en train de modifier l'Etat!",
                width: 400,
                showCancelButton: true,
                confirmButtonColor: "#988fc3",
                cancelButtonColor: "#27293D",
                confirmButtonText: "Modifier",
                cancelButtonText: "Annuler",
            }).then((result) => {
                if (result.value) {
                    this.$apollo
                        .mutate({
                            client: "MARKET",
                            mutation: gql`
                                mutation ($pk_commande: Int) {
                                    retraitPauseCommande(
                                        pk_commande: $pk_commande
                                    ) {
                                        state
                                    }
                                }
                            `,
                            variables: {
                                pk_commande: row.pk_commande,
                            },
                        })
                        .then((response) => {
                            if (response.data.retraitPauseCommande.state) {
                                this.$notify({
                                    type: "success",
                                    message: this.$t(
                                        "apiresponse.Stateupdated"
                                    ),
                                });
                                if (row.retrait_pause == 1) {
                                    row.retrait_pause = 0;
                                } else if (row.retrait_pause == 0) {
                                    row.retrait_pause = 1;
                                }
                            } else {
                                this.$notify({
                                    type: "warning",
                                    message: this.$t("apiresponse.errorupdate"),
                                });
                            }
                        })
                        .catch((error) => {
                            this.$notify({
                                type: "warning",
                                message: this.$t("apiresponse.errorupdate"),
                            });
                        });
                }
            });
        },
        ChangerStatutCommande(status, row) {
            swal.fire({
                title: "Êtes-vous sûr?",
                text: "Vous êtes en train de modifier l'Etat!",
                width: 400,
                showCancelButton: true,
                confirmButtonColor: "#988fc3",
                cancelButtonColor: "#27293D",
                confirmButtonText: "Modifier",
                cancelButtonText: "Annuler",
            }).then((result) => {
                if (result.value) {
                    this.$apollo
                        .mutate({
                            client: "MARKET",
                            mutation: gql`
                                mutation (
                                    $id_utilisateur: Int!
                                    $ref: Int!
                                    $statut: String!
                                ) {
                                    changerStatutCommande(
                                        id_utilisateur: $id_utilisateur
                                        ref: $ref
                                        statut: $statut
                                    ) {
                                        state
                                    }
                                }
                            `,
                            variables: {
                                id_utilisateur: JSON.parse(
                                    localStorage.getItem("utilisateur")
                                ).id,
                                ref: row.pk_commande,
                                statut: status,
                            },
                        })
                        .then((response) => {
                            if (response.data.changerStatutCommande.state) {
                                this.$notify({
                                    type: "success",
                                    message: this.$t(
                                        "apiresponse.Stateupdated"
                                    ),
                                });
                                if (status === "relance") {
                                    row.statut = null;
                                } else if (status === "pause") {
                                    row.statut = "pause";
                                } else if (status === "annuler") {
                                    row.statut = "annuler";
                                    row.etat = true;
                                }
                            } else {
                                this.$notify({
                                    type: "warning",
                                    message: this.$t("apiresponse.errorupdate"),
                                });
                            }
                        })
                        .catch((error) => {
                            this.$notify({
                                type: "warning",
                                message: this.$t("apiresponse.errorupdate"),
                            });
                        });
                }
            });
        },
        changeCapping(e, row) {
            let newvalue = e.target.value;

            if (newvalue == "") {
                return;
            }
            newvalue = parseInt(newvalue);

            if (JSON.parse(localStorage.getItem("utilisateur")).id != 253) {
                if (newvalue < 10) {
                    this.$notify({
                        type: "warning",
                        message: "Capping doit avoir une valeur de 10 ou plus",
                    });
                    return;
                }
            }

            swal.fire({
                title: "Êtes-vous sûr?",
                text: "Vous êtes en train de modifier le Capping!",
                width: 400,
                showCancelButton: true,
                confirmButtonColor: "#988fc3",
                cancelButtonColor: "#27293D",
                confirmButtonText: "Modifier",
                cancelButtonText: "Annuler",
            }).then((result) => {
                if (result.value) {
                    this.$apollo
                        .mutate({
                            client: "MARKET",
                            mutation: gql`
                                mutation (
                                    $id_utilisateur: Int!
                                    $ref: Int!
                                    $column: String!
                                    $value: Int!
                                    $ancien_val: Int!
                                ) {
                                    changerPrioVolumeCommande(
                                        id_utilisateur: $id_utilisateur
                                        ref: $ref
                                        column: $column
                                        value: $value
                                        ancien_val: $ancien_val
                                    ) {
                                        state
                                    }
                                }
                            `,
                            variables: {
                                id_utilisateur: JSON.parse(
                                    localStorage.getItem("utilisateur")
                                ).id,
                                ref: row.pk_commande,
                                column: "capping",
                                value: newvalue,
                                ancien_val: row.lead_par_jour,
                            },
                        })
                        .then((response) => {
                            if (response.data.changerPrioVolumeCommande.state) {
                                this.$notify({
                                    type: "success",
                                    message: "Capping a été bien modifié.",
                                });
                                row.lead_par_jour = newvalue;
                            } else {
                                this.$notify({
                                    type: "warning",
                                    message: this.$t("apiresponse.errorupdate"),
                                });
                            }
                        })
                        .catch((error) => {
                            this.$notify({
                                type: "warning",
                                message: this.$t("apiresponse.errorupdate"),
                            });
                        });
                }
            });
        },
        formatThounsends: function (value, fixe = false, number = 0) {
            if (fixe) {
                value = value.toFixed(number);
            }
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        openDetails(id) {
            let routeData = this.$router.resolve({
                name: "Détails Commande LeadMarket Admin",
                params: { commande_id: id },
            });
            window.open(routeData.href, "_blank");
        },
        openEdit(id) {
            let routeData = this.$router.resolve({
                name: "edit Commande LeadMarket Admin",
                params: { commande_id: id },
            });
            window.open(routeData.href, "_blank");
        },
        // ValiderCmdPromo() {
        //   let cmds_promo_true = ''
        //   let cmds_promo_false = ''
        //   swal.fire({
        //     title: 'Êtes-vous sûr?',
        //     text: "",
        //     width: 400,
        //     showCancelButton: true,
        //     confirmButtonColor: '#988fc3',
        //     cancelButtonColor: '#27293D',
        //     confirmButtonText: 'Modifier',
        //     cancelButtonText: 'Annuler'
        //   }).then((result) => {
        //     if (result.value) {
        //       this.ListCommande.forEach(cmd => {
        //         if (cmd.cmd_promo == true && cmd.CheckSwitchPromo) {
        //           cmds_promo_true += cmd.pk_commande + ","
        //         }
        //         else if (cmd.cmd_promo == false && cmd.CheckSwitchPromo) {
        //           cmds_promo_false += cmd.pk_commande + ","
        //         }
        //       });

        //       // cmd_promo: true
        //       if (cmds_promo_true) {
        //         this.$apollo.mutate({
        //           client: 'MARKET',
        //           mutation: gql`mutation ($id_selected: String) {
        //             valideCommandePromo($id_selected: $id_selected, cmd_promo: true) {
        //               state
        //             }
        //           }`,
        //           variables: {
        //             id_selected: cmds_promo_true.slice(0, -1)
        //           },
        //         }).then(response => {
        //           if (response.data.changerStatutCommande.state) {
        //             this.$notify({type: 'success', message: this.$t("apiresponse.Stateupdated") })
        //           }
        //           else {
        //             this.$notify({type: 'warning', message: this.$t("apiresponse.errorupdate") })
        //           }
        //         }).catch(error => {
        //           this.$notify({type: 'warning', message: this.$t("apiresponse.errorupdate") })
        //         })
        //       }
        //       // cmd_promo: false
        //       if (cmds_promo_false) {
        //         this.$apollo.mutate({
        //           client: 'MARKET',
        //           mutation: gql`mutation ($id_selected: String) {
        //             valideCommandePromo($id_selected: $id_selected, cmd_promo: false) {
        //               state
        //             }
        //           }`,
        //           variables: {
        //             id_selected: cmds_promo_false.slice(0, -1)
        //           },
        //         }).then(response => {
        //           if (response.data.changerStatutCommande.state) {
        //             this.$notify({type: 'success', message: this.$t("apiresponse.Stateupdated") })
        //           }
        //           else {
        //             this.$notify({type: 'warning', message: this.$t("apiresponse.errorupdate") })
        //           }
        //         }).catch(error => {
        //           this.$notify({type: 'warning', message: this.$t("apiresponse.errorupdate") })
        //         })
        //       }
        //     }
        //   })
        // },
        CheckSwitchPromo(row) {
            swal.fire({
                title: "Êtes-vous sûr?",
                text: "",
                width: 400,
                showCancelButton: true,
                confirmButtonColor: "#988fc3",
                cancelButtonColor: "#27293D",
                confirmButtonText: "Modifier",
                cancelButtonText: "Annuler",
            }).then((result) => {
                if (result.value) {
                    this.$apollo
                        .mutate({
                            client: "MARKET",
                            mutation: gql`
                                mutation (
                                    $id_selected: String
                                    $cmd_promo: Boolean
                                ) {
                                    valideCommandePromo(
                                        id_selected: $id_selected
                                        cmd_promo: $cmd_promo
                                    ) {
                                        state
                                    }
                                }
                            `,
                            variables: {
                                id_selected: row.pk_commande,
                                cmd_promo: !row.cmd_promo,
                            },
                        })
                        .then((response) => {
                            if (response.data.valideCommandePromo.state) {
                                this.$notify({
                                    type: "success",
                                    message: this.$t(
                                        "apiresponse.Stateupdated"
                                    ),
                                });
                                row.cmd_promo = !row.cmd_promo;
                            } else {
                                this.$notify({
                                    type: "warning",
                                    message: this.$t("apiresponse.errorupdate"),
                                });
                            }
                        })
                        .catch((error) => {
                            this.$notify({
                                type: "warning",
                                message: this.$t("apiresponse.errorupdate"),
                            });
                        });
                }
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "";
                    return;
                } else if (index === 1) {
                    sums[index] = this.formatThounsends(this.sum_capping);
                    return;
                } else if (index === 2) {
                    sums[index] = this.formatThounsends(
                        this.sum_capping_livred
                    );
                    return;
                } /* else if (index === 10 && this.rows[10].show) {
                    sums[index] = this.formatThounsends(this.sum_capping);
                    return;
                } */ /* else if (index === 11 && this.rows[11].show) {
                    sums[index] = this.formatThounsends(
                        this.sum_capping_livred
                    );
                    return;
                } */ else if (index === 3) {
                    sums[index] =
                        this.formatThounsends(
                            this.sum_ca_estimer_par_jour,
                            true,
                            2
                        ) + " €";
                    return;
                } else if (index === 4) {
                    sums[index] =
                        this.formatThounsends(this.sum_ca_temp_reel, true, 2) +
                        " €";
                    return;
                } else {
                    sums[index] = "";
                    return;
                }
            });
            return sums;
        },
        replaceUTF_8(string) {
            if (!string) return "";

            for (const [key, value] of Object.entries(
                this.$store.state.UT8_array
            )) {
                string = string.replaceAll(value, key);
            }

            return string;
        },
        calculateCaEstimer(cmd) {
            let days_week_livre = 0;
            let startDate = moment(this.StartDate || new Date());
            const endDate = moment(this.EndnDate || new Date());
            const days_cmd = cmd.jours;
            const db_livraison = moment(cmd.db_livraison || new Date());
            const prix_lead = cmd.ligne_commande[0].prix_unitaire || 0;
            const capping = cmd.lead_par_jour || 0;

            if (db_livraison.diff(startDate, "days") > 0) {
                startDate = db_livraison;
            }

            if (days_cmd) {
                for (
                    var m = startDate;
                    m.diff(endDate, "days") <= 0;
                    m.add(1, "days")
                ) {
                    if (
                        days_cmd
                            .toLowerCase()
                            .includes(m.locale("fr").format("dddd"))
                    ) {
                        days_week_livre++;
                    }
                }
            } else {
                days_week_livre = startDate.diff(endDate, "days") + 1;
            }

            return days_week_livre * capping * prix_lead;
        },
        CustomSort_CaEstime(a, b) {
            return (
                a.lead_par_jour * a.ligne_commande[0].prix_unitaire -
                b.lead_par_jour * b.ligne_commande[0].prix_unitaire
            );
        },
        CustomSort_CaReel(a, b) {
            return (
                a.capping_livre * a.ligne_commande[0].prix_unitaire -
                b.capping_livre * b.ligne_commande[0].prix_unitaire
            );
        },
    },
    mounted() {
        this.SkipQuery = false;
    },
};
</script>

<style>
.transition-width {
    transition: width 0.3s ease-in-out;
}
.progress {
    background-color: rgb(95 95 95) !important;
    -webkit-box-shadow: none !important;
}
.bg-success-bar {
    background-color: rgb(0, 243, 109);
}
.text-success-bar {
    color: rgb(0, 243, 109);
}
.card .card-commande {
    padding: 5px 20px !important;
}
</style>
